export const GA_HDFC_OV_OTP_INIT = {
    CATEGORY: 'HDFC_Other_Vertical',
    ACTION: 'HDFC_OV_Form',
    LABEL: 'HDFC_OV_OTP_Init'
};

export const GA_HDFC_OV_OTP_SUBMIT = {
    CATEGORY: 'HDFC_Other_Vertical',
    ACTION: 'HDFC_OV_Form',
    LABEL: 'HDFC_OV_OTP_Submit'
};

export const GA_QH_DHL_FORM_INIT_OTP_CLICK = {
    CATEGORY: 'RealEstate',
    ACTION: 'qh_dhl_form',
    LABEL: 'qh_dhl_form_init_otp_click'
};

export const GA_QH_DHL_FORM_SUBMIT_OTP_CLICK = {
    CATEGORY: 'RealEstate',
    ACTION: 'qh_dhl_form',
    LABEL: 'qh_dhl_form_submit_otp_click'
};
